import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import Highlighter from "react-highlight-words";
import {
  FaFacebookF,
  FaGlobe,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { BarLoader } from "react-spinners";
import { useFirestore } from "reactfire";
import { useAppUser } from "../../../contexts/user-context/UserContext";
import Pagination from "../../../shared/components/ui/pagination/Pagination";
import { Country } from "../../../shared/constants/Constant";
import { IndustryTags } from "../../dashboard/containers/teams/containers/edit-team/TeamProfileEditComponent";
import { useHistory } from "react-router-dom";
import { MApplicationCountry } from "../../../contexts/applications-context/ApplicationsContext";
import ieeeLogo from "../../../shared/resources/in-logo-small-no-text.png";

/**
 * company name
 * country
 * sector
 * year
 * position
 *
 *
 */
interface Filter {
  companyName: string;
  country: MApplicationCountry;
  sector?: IndustryTags | "all" | "not";
  year?: number;
  // position?: number;
}

export interface TeamData {
  id?: string;
  logo?: string;
  industryTags?: IndustryTags[];
  founded?: string;
  facebook?: string;
  linkedIn?: string;
  twiter?: string;
  youtube?: string;
  website?: string;
  instagram?: string;
  companyName?: string;
  oneLineIntro?: string;
  overview?: string;
  country?: Country;
  createdAt: Date;
  updatedAt: Date;
}
interface IState {
  companies: TeamData[];
  loading: boolean;
  selectedCompany: TeamData;
}

const PublicCompanies = () => {
  const ITEM_COUNT_IN_PAGE: number = 10;
  const initialFilters: Filter = {
    companyName: "",
    country: MApplicationCountry.SELECT_COUNTRY,
    // position: 0,
    sector: "not",
    year: -1,
  };
  const initialState: IState = {
    companies: [],
    loading: false,
    selectedCompany: {} as any,
  };

  const initialPagination = {
    total_pages: 0,
    page_number: 0,
  };

  const [filters, setFilters] = useState(initialFilters);
  const [state, setState] = useState(initialState);
  const [companies, setCompanies] = useState<TeamData[]>([]);
  const [pagination, setPagination] = useState(initialPagination);
  const [years, setYears] = useState<string[]>([]);

  const store = useFirestore();
  const appUser = useAppUser();
  const { push } = useHistory();
  // const app = useAppContext();

  const itEnumToList = (object: any) => {
    return Object.keys(object).map((key) => object[key] as string);
  };

  useEffect(() => {
    if (state.companies.length % ITEM_COUNT_IN_PAGE === 0) {
      const totalPages = state.companies.length / ITEM_COUNT_IN_PAGE;
      setPagination((ps) => ({ ...ps, total_pages: totalPages }));
    } else {
      const totalPages =
        Math.floor(state.companies.length / ITEM_COUNT_IN_PAGE) + 1;
      setPagination((ps) => ({ ...ps, total_pages: totalPages }));
    }
  }, [state.companies]);

  useEffect(() => {
    setYears((ps) => {
      const years = companies
        .filter((c) => c.founded)
        .map((c) => c.founded) as string[];
      const uyears = years.filter(function(item, pos) {
        return +years?.indexOf(item) === pos;
      });
      return uyears.sort((a, b) => +a - +b);
    });
  }, [companies]);

  useEffect(() => {
    let query:
      | firebase.firestore.Query
      | firebase.firestore.CollectionReference = store.collection("teams");

    return query.where("isPublished", "==", true).onSnapshot({}, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          const data: any = change.doc.data();
          setCompanies((ps) => {
            ps.push({
              ...data,
              id: change.doc.id,
              createdAt: new Date(data.createdAt * 1000),
              updatedAt: new Date(data.updatedAt * 1000),
            });

            return Object.assign([], ps);
          });
        }
        if (change.type === "modified") {
          setCompanies((ps) => {
            const modified = ps.map((a) => {
              if (a.id === change.doc.id) {
                return {
                  ...(change.doc.data() as any),
                  id: change.doc.id,
                  createdAt: new Date(change.doc.data().createdAt * 1000),
                  updatedAt: new Date(change.doc.data().createdAt * 1000),
                };
              } else {
                return a;
              }
            });

            return Object.assign([], modified);
          });
        }
        if (change.type === "removed") {
          setCompanies((ps) => {
            const removed = ps.filter((a) => a.id !== change.doc.id);
            return Object.assign([], removed);
          });
        }
      });
    });
  }, [store, appUser.country, appUser.userRole]);

  useEffect(() => {
    setPagination((ps) => {
      return { ...ps, page_number: 0 };
    });
  }, [filters.country]);

  // useEffect(() => {
  //   setState((ps) => {
  //     ps.companies = companies;
  //     return { ...ps, companies: [...ps.companies] };
  //   });
  // }, [companies]);

  /**
   * company name
   * country
   * sector
   * year
   * position
   *
   *
   */
  useEffect(() => {
    let c_companies = companies;

    if (filters.companyName.trim().length > 0) {
      c_companies = c_companies.filter((company) =>
        company.companyName
          ?.toLowerCase()
          .includes(filters.companyName.toLowerCase())
      );
    }
    if (filters.country !== MApplicationCountry.ALL) {
      if (filters.country !== MApplicationCountry.SELECT_COUNTRY) {
        c_companies = c_companies.filter(
          (mem) => mem.country?.toString() === filters.country?.toString()
        );
      }
    }
    // if (filters.position && filters.position > 0) {
    //   c_companies = c_companies.filter((members) =>
    //     members.companyName
    //       ?.toLowerCase()
    //       .includes(filters.companyName.toLowerCase())
    //   );
    // }
    if (
      filters.sector &&
      filters.sector !== "all" &&
      filters.sector !== "not"
    ) {
      if (filters.sector === "Others") {
        c_companies = c_companies.filter(
          (company) =>
            company.industryTags &&
            company.industryTags.filter(
              (it) => itEnumToList(IndustryTags).indexOf(it) === -1
            ).length > 0
        );
      } else {
        c_companies = c_companies.filter(
          (company) =>
            company.industryTags &&
            company.industryTags.filter((it) => it === filters.sector).length >
              0
        );
      }
    }
    // eslint-disable-next-line eqeqeq
    if (filters.year && filters.year != 0 && filters.year != -1) {
      c_companies = c_companies.filter(
        // eslint-disable-next-line eqeqeq
        (company) => company.founded == filters.year
      );
    }
    setState((ps) => {
      return { ...ps, companies: c_companies };
    });
  }, [
    filters.companyName,
    filters.country,
    // filters.position,
    filters.sector,
    filters.year,
    companies,
  ]);

  const paginate = (
    array: TeamData[],
    page_number: number,
    page_size: number
  ): TeamData[] =>
    array.slice(page_number * page_size, (page_number + 1) * page_size);

  const getCountryString = (c: Country) => {
    switch (c) {
      case Country.BOSNIA:
        return "Bosnia and Herzegovina";
      case Country.JAMAICA:
        return "Jamaica";
      case Country.MALAYSIA:
        return "Malaysia";
      case Country.INDIA:
        return "India";
      default:
        return "Sri Lanka";
    }
  };

  return (
    <div>
      <Container
        fluid
        style={{
          paddingTop: "20px",
          paddingLeft: "100px",
          paddingRight: "100px",
          paddingBottom: "10px",
        }}
      >
        <Row style={{ marginBottom: "30px" }}>
          <Col style={{ display: "flex", alignItems: "center" }}>
            <img src={ieeeLogo} alt="" style={{ width: "70px" }} />
            <h3
              style={{ color: "#006699", marginLeft: "30px", fontSize: "40px" }}
            >
              IEEE Innovation Nation Fellows
            </h3>
          </Col>
        </Row>
        <Row className="cfilterp">
          <Col
            xs={12}
            md={2}
            xl={3}
            className=" d-flex align-items-center ml-md-0 my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <input
                className="app-input input-small search-img"
                style={{ paddingRight: "30px" }}
                placeholder="Company Name"
                value={filters.companyName}
                onChange={(e) => {
                  setFilters({ ...filters, companyName: e.target.value });
                }}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={2}
            xl={2}
            className="d-flex align-items-center my-1 my-md-0"
            style={{ minWidth: "150px" }}
          >
            <div style={{ flex: "1" }}>
              <select
                className="app-input input-small filter-img"
                placeholder="Country"
                value={filters.country}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    country: e.target.value as any,
                  });
                }}
              >
                <option
                  value={MApplicationCountry.SELECT_COUNTRY}
                  disabled
                  hidden
                >
                  Select Country
                </option>
                <option value={MApplicationCountry.ALL}>All Countries</option>
                <option value={MApplicationCountry.MALAYSIA}>Malaysia</option>
                <option value={MApplicationCountry.INDONESIA}>Indonesia</option>
                <option value={MApplicationCountry.SRI_LANKA}>Sri Lanka</option>
                <option value={MApplicationCountry.BOSNIA}>
                  Bosnia and Herzegovina
                </option>
                <option value={MApplicationCountry.JAMAICA}>Jamaica</option>
                <option value={MApplicationCountry.INDIA}>India</option>
              </select>
            </div>
          </Col>

          <Col
            xs={12}
            md={2}
            xl={3}
            className="d-flex align-items-center my-1 my-md-0"
            style={{ minWidth: "150px" }}
          >
            <div style={{ flex: "1" }}>
              <select
                className="app-input input-small filter-img"
                value={filters.sector}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    sector: e.target.value as any,
                  });
                }}
              >
                <option value="not" disabled hidden>
                  Select Sector
                </option>
                <option value="all">All Sectors</option>
                {itEnumToList(IndustryTags).map((tag, index) => (
                  <option key={index} value={tag}>
                    {tag}
                  </option>
                ))}
              </select>
            </div>
          </Col>
          <Col
            xs={12}
            md={2}
            xl={2}
            className="d-flex align-items-center my-1 my-md-0"
            style={{ minWidth: "150px" }}
          >
            <div style={{ flex: "1" }}>
              <select
                className="app-input input-small filter-img"
                value={filters.year}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    year: e.target.value as any,
                  });
                }}
              >
                <option value={-1} disabled hidden>
                  Select Year
                </option>
                <option value={0}>All Years</option>
                {years.map((year, index) => (
                  <option key={index} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </Col>
          {/* <Col
            xs={12}
            md={2}
            xl={2}
            className="d-flex align-items-center my-1 my-md-0"
            style={{ minWidth: "150px" }}
          >
            <div style={{ flex: "1" }}>
              <select
                className="app-input input-small filter-img"
                value={filters.position}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    position: e.target.value as any,
                  });
                }}
              >
                <option value={undefined} disabled hidden>
                  Position
                </option>
                <option value="all">All</option>
                {Array.from(Array(100).keys()).map((p) => (
                  <option value={p + 1}>{p + 1}</option>
                ))}
              </select>
            </div>
          </Col> */}
          <Col
            xs={12}
            md={2}
            xl={2}
            className="d-flex align-items-center my-1 my-md-0"
          >
            <div style={{ flex: "1" }}>
              <button
                className="app-button "
                style={{
                  backgroundColor: "#006699",
                  padding: "7px 30px 7px 30px",
                }}
                onClick={() => setFilters(initialFilters)}
              >
                Clear
              </button>
            </div>
          </Col>
        </Row>
        <Row className="mt-4" style={{ fontSize: "16px" }}>
          <Col xs={12}>
            <BarLoader
              height={4}
              width={"100%"}
              color={"#006699"}
              loading={state.loading}
            />
          </Col>
        </Row>
        <Row className="mt-2 scroll" style={{ overflowX: "auto" }}>
          <Col xs={12} style={{ minHeight: "520px" }}>
            <table className="table-applications table-custom">
              <colgroup>
                <col span={1} style={{ width: "10%" }} />
                <col span={1} style={{ width: "15%" }} />
                <col span={1} style={{ width: "30%" }} />
                <col span={1} style={{ width: "10%" }} />
                <col span={1} style={{ width: "10%" }} />
                <col span={1} style={{ width: "10%" }} />
                {/* <col span={1} style={{ width: "5%" }} /> */}
                <col span={1} style={{ width: "15%" }} />
              </colgroup>
              <thead>
                {/* 1. Company logo
                    2. Name
                    3. Company Overview
                    4. Sector
                    5. Country
                    6. Year
                    7. Social Media  
                */}
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Company Overview</th>
                  <th>Sector</th>
                  <th>Country</th>
                  <th>Year</th>
                  {/* <th>Pos.</th> */}
                  <th>Social Media</th>
                </tr>
              </thead>
              <tbody>
                {paginate(
                  state.companies,
                  pagination.page_number,
                  ITEM_COUNT_IN_PAGE
                )
                  .sort((a, b) => b.updatedAt.getTime() - a.updatedAt.getTime())
                  .map((company: TeamData, index: number) => (
                    <tr
                      key={index}
                      onClick={() => {
                        push(`company/${company.id}`);
                      }}
                    >
                      <td>
                        <img
                          style={{ width: "150px" }}
                          src={company.logo}
                          alt={company.oneLineIntro}
                        />
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "18px" }}>
                        <Highlighter
                          highlightClassName="highlightClass"
                          searchWords={[filters.companyName || ""]}
                          highlightTag={({ children, highlightIndex }: any) => {
                            return (
                              <span className="highlightClass">{children}</span>
                            );
                          }}
                          autoEscape={true}
                          textToHighlight={company.companyName || ""}
                        />
                      </td>
                      <td>
                        <p
                          style={{
                            height: "200px",
                            overflowY: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {company.overview}
                        </p>
                      </td>
                      <td>
                        {company.industryTags?.map((t, index) => (
                          <>
                            <label key={index}>{t}</label>
                            <br />
                          </>
                        ))}
                      </td>
                      <td>
                        {getCountryString(company.country || Country.SRI_LANKA)}
                      </td>
                      <td>{company.founded}</td>
                      {/* <td>#{index + 1}</td> */}
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignContent: "center",
                          }}
                        >
                          {company?.facebook && (
                            <a
                              href={company.facebook}
                              target="_blank"
                              className="smedia"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FaFacebookF
                                style={{ color: "#4267B2", cursor: "pointer" }}
                              />
                            </a>
                          )}
                          {company?.twiter && (
                            <a
                              href={company.twiter}
                              target="_blank"
                              className="smedia"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FaTwitter
                                style={{ color: "#1DA1F2", cursor: "pointer" }}
                              />
                            </a>
                          )}
                          {company?.youtube && (
                            <a
                              href={company.youtube}
                              target="_blank"
                              className="smedia"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FaYoutube
                                style={{ color: "#c4302b", cursor: "pointer" }}
                              />
                            </a>
                          )}
                          {company?.linkedIn && (
                            <a
                              href={company.linkedIn}
                              target="_blank"
                              className="smedia"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FaLinkedinIn
                                style={{ color: "#0e76a8", cursor: "pointer" }}
                              />
                            </a>
                          )}
                          {company?.website && (
                            <a
                              href={company?.website}
                              target="_blank"
                              className="smedia"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FaGlobe
                                style={{ color: "#0e76a8", cursor: "pointer" }}
                              />
                            </a>
                          )}
                          {company?.instagram && (
                            <a
                              href={company?.instagram}
                              target="_blank"
                              className="smedia"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FaInstagram
                                style={{ color: "#0e76a8", cursor: "pointer" }}
                              />
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </Col>
          <Col xs={12}>
            <Pagination
              pInfo={{
                page: pagination.page_number,
                totalPages: pagination.total_pages,
              }}
              onPageChanged={(page) => {
                setPagination({ ...pagination, page_number: page });
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PublicCompanies;
